// Stacked bar segments for one day's project hours inside the dashboard chart.
import { Box } from '@mui/material';
import { formatHours } from '@/components/ui/formatHours';
import { getProjectColor } from '@/utils/colorUtils';

const BAR_MAX_HOURS = 8;

const ProjectStack = ({
  projects,
  capHours,
  scaleMaxHours = BAR_MAX_HOURS,
}) => {
  const scale =
    scaleMaxHours && scaleMaxHours > 0 ? scaleMaxHours : BAR_MAX_HOURS;
  const shown =
    capHours === null || capHours === undefined
      ? projects
      : (() => {
          let remaining = capHours;
          return projects
            .map((p) => {
              const h = Math.max(0, Math.min(p.hours, remaining));
              remaining -= h;
              return { ...p, hours: h };
            })
            .filter((p) => p.hours > 0);
        })();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column-reverse',
      }}
    >
      {shown.map((p) => {
        const segmentLabel = `${p.name}, ${formatHours(p.hours)}`;
        return (
          <Box
            key={p.name}
            data-testid="project-stack-segment"
            aria-label={segmentLabel}
            title={segmentLabel}
            sx={{
              width: '100%',
              bgcolor: getProjectColor(p.projectId ?? p.name, p.colorIndex),
              height: `${(p.hours / scale) * 100}%`,
            }}
          />
        );
      })}
    </Box>
  );
};

export default ProjectStack;
